// assets/product-creditel.js
// Actualiza dinámicamente el "Precio Creditel" cuando cambia el precio visible.

(function () {
  function parsePriceToNumber(text) {
    if (!text) return null;

    var match = text.replace(/\s/g, '').match(/[-+]?[0-9.,]+/);
    if (!match) return null;

    var num = match[0];
    var hasComma = num.indexOf(',') !== -1;
    var hasDot = num.indexOf('.') !== -1;

    // Manejo básico para 1.234,56 / 1,234.56 / 1234,56 / 1234.56
    if (hasComma && hasDot) {
      if (num.lastIndexOf('.') > num.lastIndexOf(',')) {
        // 1,234.56 -> quitamos comas
        num = num.replace(/,/g, '');
      } else {
        // 1.234,56 -> quitamos puntos y usamos coma como decimal
        num = num.replace(/\./g, '').replace(',', '.');
      }
    } else if (hasComma) {
      num = num.replace(',', '.');
    }

    var value = parseFloat(num);
    return isNaN(value) ? null : value;
  }

  function getCurrencyPrefix(text) {
    if (!text) return '';
    var match = text.match(/^[^\d\-+]+/);
    return match ? match[0].trim() + ' ' : '';
  }

  function formatNumberWithThousands(value) {
    try {
      return value.toLocaleString();
    } catch (e) {
      return String(value);
    }
  }

  function updateCreditelPrice() {
    var priceContainer = document.querySelector('[data-gm="price"]');
    var creditelContainer = document.querySelector('[data-creditel-price]');
    if (!priceContainer || !creditelContainer) return;

    var saleEl = priceContainer.querySelector('.price-item--sale');
    var regularEl = priceContainer.querySelector('.price-item--regular');

    var sourceEl = saleEl || regularEl;
    if (!sourceEl) return;

    var priceText = sourceEl.textContent || '';
    var basePrice = parsePriceToNumber(priceText); // unidades de moneda
    if (basePrice == null || basePrice <= 0) {
      creditelContainer.style.display = 'none';
      return;
    }

    // 15% menos, redondeo entero sin decimales
    var creditelValue = Math.round(basePrice * 0.85);

    var prefix = getCurrencyPrefix(priceText);
    var formatted = prefix + formatNumberWithThousands(creditelValue);

    var valueEl = creditelContainer.querySelector('.product-creditel-line__value');
    if (!valueEl) return;

    valueEl.textContent = formatted;
    creditelContainer.style.display = '';
  }

  document.addEventListener('DOMContentLoaded', function () {
    var priceContainer = document.querySelector('[data-gm="price"]');
    var creditelContainer = document.querySelector('[data-creditel-price]');
    if (!priceContainer || !creditelContainer) return;

    updateCreditelPrice();

    // Observar cambios en el bloque de precio (cambio de variante, scripts, etc.)
    var observer = new MutationObserver(function () {
      updateCreditelPrice();
    });

    observer.observe(priceContainer, {
      childList: true,
      subtree: true,
      characterData: true
    });
  });
})();
